import './archive-featured-card.scss'

import _ from 'lodash';
import { first } from 'rxjs/operators';
import { defineComponent, PropType } from 'vue';
import { faCamera, faEdit } from '@fortawesome/free-solid-svg-icons';

import { ArchiveResource, getTranslatedString, LinkableArchiveItemResource } from '@skinsoft/types';
import { archiveSelectors, thesaurusTermSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { ActionType, TitleClickAction } from '@skinsoft/ui';
import { BASIC_ARCHIVE_CARD_TITLE_CLICKED } from '../../../events';
import { BasicArchiveCard } from '../basic-archive-card';

export const ArchiveFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBasicArchiveCard: BasicArchiveCard,
    },
    props: {
        archive: { type: Object as PropType<ArchiveResource>, required: true },
        clickableTitle: {
            type: Boolean,
            default: false,
        },
        titleClickAction: {
            type: Object as PropType<TitleClickAction>
        },
        displayedButtons: {
            type: Array,
        },
    },
    template: require('./archive-featured-card.html'),
    data() {
        return {
            archiveTypes: '',
            institution: '',
            BASIC_ARCHIVE_CARD_TITLE_CLICKED: BASIC_ARCHIVE_CARD_TITLE_CLICKED,
        }
    },
    mounted() {
        this.updateArchiveTypes()
        this.updateInstitution()
    },
    computed: {
        path(): string {
            return archiveSelectors.path(this.archive) ?? ''
        },
    },
    methods: {
        async updateArchiveTypes() {
            const types = archiveSelectors.archiveTypes(this.archive)

            let res = ''
            const separator = " ; "

            if(types?.length) {
                for(const type of types) {
                    if(type?.archiveType) {
                        const thesaurusTermId = (type.archiveType as any).ref ?? type.archiveType
                        const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(thesaurusTermId).toPromise()
                        if(thesaurusTerm) {
                            const thesaurusTermTranslatedString = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                            if(thesaurusTermTranslatedString) {
                                const thesaurusTermValue = getTranslatedString(
                                    thesaurusTermTranslatedString,
                                    this.$i18n.locale
                                )
                                if(thesaurusTermValue) {
                                    res += `${thesaurusTermValue}${separator}`
                                }
                            }
                        }
                    }
                }
            }

            if(res.length) {
                res = res.slice(0, -separator.length)
            }
            this.archiveTypes = res
        },
        async updateInstitution() {
            let res = ''

            const institutionId = archiveSelectors.institution(this.archive)

            if(institutionId) {
                const institutionName = await this.$institutionDataStore.getInstitutionName(
                    institutionId,
                    this.getAppLocale()
                ).toPromise()

                if(institutionName) {
                    res = institutionName
                }
            }

            this.institution = res
        },
        onTitleClicked() {
            if(this.titleClickAction) {
                if(this.titleClickAction && this.titleClickAction.action === ActionType.EDIT){
                    this.$router.push({
                        name: this.titleClickAction.targetRouteName,
                        params: {archiveId: this.archive.id as string},
                        query: {imageChoice: 'false'}
                    })
                }
            }
        },
        isDisplayed(button: any) {
            switch (button.condition) {
                case undefined:
                    return true
            }
        },
        getIcon(iconName: string) {
            switch (iconName) {
                case 'camera':
                    return faCamera
                case 'edit':
                    return faEdit
            }
        },
        performAction(button: any) {
            switch (button.type) {
                /*case 'camera':
                    let fileInputElement = this.$refs.camera[0]
                    if (fileInputElement instanceof HTMLElement) {
                        fileInputElement.click()
                    }
                    break
                case 'modifyItemRecord':
                    this.$router.push({
                        name: this.targetRouteName,
                        params: { itemId: this.searchFeatured.itemId },
                        query: { imageChoice: 'false' },
                    })
                    break*/
                case 'createNewReport':
                    this.createNewReport(button.targetRouteName)
                    break
                /*case 'createNewReportFromLast':
                    this.createNewReport(true)
                    break
                case 'consultLastReport':
                    this.$router.push({
                        name: button.route,
                        params: { reportId: this.lastReportId }
                    })*/
            }
        },
        async createNewReport(targetRouteName: string) {
            const newReportId = await this.createReportAndGetId()

            this.$router.push({
                name: targetRouteName,
                params: {
                    reportId: newReportId,
                },
            })
        },
        async createReportAndGetId(): Promise<string> {
            const report = await this.$conditionReportDataStore.create().pipe(first()).toPromise()

            _.set(report, 'conditionReportCS.comments', [])
            // Setting concerned item - temporary, TODO use right field when available
            _.set(report, 'conditionReportCS.linkableItem', {
                linkableItem: this.archive.id,
                linkableItemReferenceType: "Archive",
            } as LinkableArchiveItemResource)
            await this.$conditionReportDataStore.update(report.id, report).pipe(first()).toPromise()

            return report.id
        },
    },
    watch: {
        archive() {
            this.updateArchiveTypes()
            this.updateInstitution()
        },
    },
})
